export default __webpack_public_path__ + "static/media/premium-clock-icon-melroy.0000c1c4035bfba986a8df7f020063c0.svg";